<template>
  <div class="header-wrapper padding-ml">
    <challenge-header
      :challenge-name="challenge.name"
      :short-description="challenge.shortDescription ?? ''"
      class="texts"
    />
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import ChallengeHeader from '../ChallengeHeader/ChallengeHeader.vue';
import { useChallengeStore } from '../../stores/challenge';

const challengeStore = useChallengeStore();
const {
  challenge,
} = storeToRefs(challengeStore);

</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/mixins';
@import '@riseupil/base-ui/src/scss/riseup-vars';
@import '@riseupil/base-ui/src/scss/spacings.scss';

.header-wrapper {
  height: 180px;
  background-color:#FFA6C4;
  display: grid;
  grid-template-columns: 2.5fr 0.5fr;
  gap: 16px;

  .texts {
    margin-top: auto;
  }

}

</style>
